<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path:'/'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>管理员列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-text>管理员：</el-text>
        <el-col :span="4">
          <el-input
            placeholder="请输入内容"       
            clearable
            v-model="txt1">
            </el-input>  
        </el-col>
        <el-row>
          <el-button @click="getPage" circle>
            <el-icon><Search /></el-icon>
          </el-button>
        </el-row>
      </el-row>
      <!-- 新增、批量删除按钮 -->
      <el-row class="bt">
        <el-button type="primary" @click="addClick">+新增</el-button>
      </el-row>
      <!-- 基地管理列表 -->
      <el-table :data="tableData" style="width:100%">
        <el-table-column prop="username" label="管理员" />
        <el-table-column prop="roleName" label="角色" />
        <el-table-column prop="stateName" label="状态" />

        <el-table-column fixed="right" label="操作" width="150">
          <template #default="scope">
            <el-button link type="primary" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button link type="primary" size="small" @click="handleDelete(scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="kh-page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 50, 100, 500]"
          :page-size="currentPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

  
<script>

  export default{
    data(){
      return {
        tableData : [],
        txt1: '',
        currentPage: 1,
        currentPageSize: 20,
        totalCount: 0
      }
    },
    mounted:function(){
      this.getPage()
    },
    methods:{
      //添加
      addClick(){
        this.$router.push("/Admin/AdminsEdit")
      },
      getPage(){
        var ths = this
        var queryBO = {
          name: this.txt1,
          page:1,
          pageSize:5,
          sortField: ''
        }
        ths.$post('/Admins/queryPage',queryBO)
        .then(function (res) { 
            if(res.success){
              ths.tableData = res.data.rows
            }
        })
        .catch(function (err) {
          console.log(err)
        })    
      },
      handleEdit(row){
        this.$router.push("/Admin/AdminsEdit?id="+row.id)
      },
      handleDelete(row){
        if(confirm("确认要删除吗？")){
          var ths = this
          ths.$get('/Admins/delete?id='+row.id)
          .then(function (res) { 
              alert(res.msg)
              if(res.success){
                ths.getPage()
              }
          })
          .catch(function (err) {
            console.log(err)
          })    
        }
      },
      handleSizeChange(val) {
        this.currentPageSize = val
      },
      handleCurrentChange(val) {
        this.currentPage = val
      }
    }
  }

</script>

<style>
.bt{
  padding:20px 0;
}
</style>